import React from 'react';
import { StyledTickText } from './styled';
function defaultFormatter(value, unit) {
    return `${value}${unit || ''}`;
}
export const Tick = ({ payload, tickFormatter, unit, ...props }) => {
    // can`t use assignment in destructuring
    // Terser throws: Unexpected token punc «:», expected punc «,»
    const formatter = tickFormatter ? tickFormatter : defaultFormatter;
    return (React.createElement(StyledTickText, { payload: payload, ...props }, formatter(payload.value, unit)));
};
